import { gql } from '@apollo/client';

// Task Management Mutations
export const GENERATE_TASKS = gql`
  mutation GenerateProjectTasks($projectId: String!) {
    generateProjectTasks(projectId: $projectId) {
      success
      message
      tasksGenerated
      tasks {
        id
        title
        description
        type
        status
        priority
        timeline {
          start
          end
          frameStart
          frameEnd
        }
        estimatedMinutes
        actualMinutes
        dependencies
        tags
        editorNotes
        createdBy
        createdAt
        updatedAt
        completedAt
        reviewComments
        generatedFromAnnotations
      }
    }
  }
`;

export const ENHANCE_TASKS_WITH_AI = gql`
  mutation EnhanceTasksWithAI($projectId: String!) {
    enhanceTasksWithAI(projectId: $projectId) {
      success
      message
      tasksEnhanced
      aiProcessingTime
      tasks {
        id
        title
        description
        type
        priority
        timeline {
          start
          end
          frameStart
          frameEnd
        }
        aiInstructions
        estimatedMinutes
        dependencies
        tags
        editorNotes
        generatedFromAnnotations
      }
    }
  }
`;

export const EXPORT_PROJECT_ZIP = gql`
  mutation GenerateProjectZip($projectId: String!) {
    generateProjectZip(projectId: $projectId) {
      success
      message
      downloadUrl
      filename
      sizeBytes
      expiresAt
    }
  }
`;

export const UPDATE_TASK_TIMELINE = gql`
  mutation UpdateTaskTimeline($taskId: String!, $start: Float!, $end: Float!) {
    updateTaskTimeline(taskId: $taskId, start: $start, end: $end) {
      id
      timeline {
        start
        end
        frameStart
        frameEnd
      }
      updatedAt
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($taskId: String!) {
    deleteTask(taskId: $taskId) {
      success
      message
    }
  }
`;

export const CREATE_TASK = gql`
  mutation AddCustomTask($projectId: String!, $task: TaskInput!) {
    addCustomTask(projectId: $projectId, task: $task) {
      id
      title
      description
      type
      status
      priority
      timeline {
        start
        end
        frameStart
        frameEnd
      }
      assetRefs
      assetInstructions
      aiInstructions
      estimatedMinutes
      actualMinutes
      dependencies
      tags
      editorNotes
      createdBy
      createdAt
      updatedAt
      completedAt
      reviewComments
      generatedFromAnnotations
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($projectId: String!, $taskId: String!, $updates: TaskUpdateInput!) {
    updateTask(projectId: $projectId, taskId: $taskId, updates: $updates) {
      id
      title
      description
      type
      status
      priority
      timeline {
        start
        end
        frameStart
        frameEnd
      }
      assetRefs
      assetInstructions
      aiInstructions
      estimatedMinutes
      actualMinutes
      dependencies
      tags
      editorNotes
      reviewComments
      updatedAt
    }
  }
`;

// AI Preview Mutations (for non-destructive AI enhancement)
export const PREVIEW_ENHANCE_TASKS = gql`
  mutation PreviewEnhanceTasks($projectId: String!) {
    previewEnhanceTasks(projectId: $projectId) {
      suggestions {
        title
        description
        type
        priority
        timeline {
          start
          end
        }
        aiInstructions
        estimatedMinutes
        tags
        generatedFromAnnotations
      }
      raw
    }
  }
`;

export const COMMIT_ENHANCE_TASKS = gql`
  mutation CommitEnhanceTasks($projectId: String!) {
    commitEnhanceTasks(projectId: $projectId) {
      id
      tasks {
        id
        title
        description
        aiInstructions
        estimatedMinutes
        updatedAt
      }
    }
  }
`;

// Project Permission Query
export const GET_PROJECT_WITH_PERMISSIONS = gql`
  query GetProjectWithPermissions($projectId: ID!) {
    editingRequest(id: $projectId) {
      id
      projectName
      canEditTasks
      tasks {
        id
        title
        description
        type
        status
        priority
        timeline {
          start
          end
          frameStart
          frameEnd
        }
        assetRefs
        assetInstructions
        aiInstructions
        estimatedMinutes
        actualMinutes
        dependencies
        tags
        editorNotes
        createdBy
        createdAt
        updatedAt
        completedAt
        reviewComments
        generatedFromAnnotations
      }
      taskProgress {
        totalTasks
        completedTasks
        inProgressTasks
        estimatedTotalMinutes
        actualTotalMinutes
        completionPercentage
        lastUpdated
      }
      videoDuration
    }
  }
`;
